export default __webpack_public_path__ + "static/media/stanford.022f48d7.jpg";